<div>
	<i18n path="vm.root.shop.bulk.main.step2.down-payment-received.content" tag="p">
		<strong>{{ $t('vm.root.shop.bulk.main.step2.down-payment-received.strong') }}</strong>
		<router-link :to="{name: 'shop'}" :title="$t('vm.root.shop.bulk.main.step2.down-payment-received.link.title')">
			{{ $t('vm.root.shop.bulk.main.step2.down-payment-received.link.label') }}
		</router-link>
	</i18n>
</div>
